'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var google_map_markers = {};

exports.__exports = google_map_markers;
